import loadSessionModule from './modules/Session.module';
const loadAccountMenuModule = () => ({
    hasRouter: false,
    modules: [loadSessionModule()],
});
export default loadAccountMenuModule;
